import {
  Header_default
} from "./chunk-SMLT6GZW.mjs";
import {
  Spacer_default
} from "./chunk-TFAZJAPA.mjs";
import {
  Paragraph
} from "./chunk-PZCCRLSA.mjs";
import {
  useToggle_default
} from "./chunk-CRERXMKA.mjs";
import {
  BASE
} from "./chunk-IBEWOW4A.mjs";
import {
  React,
  __name,
  init_react_import
} from "./chunk-65BGW52G.mjs";

// components/Card/Card.tsx
init_react_import();
import { Spacing } from "@persona-id/design-tokens";
import { ChevronDownIcon, ChevronUpIcon } from "@persona-id/design-tokens/icons";
import styled, { css } from "styled-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
__name(_extends, "_extends");
var Card = styled("div")`
  border-radius: ${({ theme }) => {
  return theme.card.borderRadius;
}};
  display: flex;
  flex-direction: column;
  margin-bottom: ${Spacing[4]};
  background-color: ${({ theme }) => theme.color.background.primary};
  font-family: ${({ theme }) => theme.text.fontFamily.base};
  ${({ elevated }) => elevated && css`
      box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.12);
    `}
`;
var Body = styled("section")`
  margin: 0;
  padding: ${({ padding }) => padding ?? Spacing[5]};
  display: grid;
  grid-auto-flow: row;
  grid-gap: ${({ gap }) => gap != null ? gap : BASE}px;
  /**
    * Prevent grid blowout
    * https://css-tricks.com/preventing-a-grid-blowout/
    */
  grid-template-columns: minmax(0, 1fr);
`;
var IconContainer = styled("div")`
  margin-right: ${Spacing[3]};
  display: flex;
  align-items: center;

  > svg {
    height: 24px;
    width: 24px;
  }
`;
var ImageWrapper = styled("div")`
  width: 100%;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.card.borderRadius} ${({ theme }) => theme.card.borderRadius}
    0px 0px;

  ${({ height }) => {
  return css`
      height: ${height}px;
    `;
}};

  > img,
  svg {
    width: 100%;
    border-radius: ${({ theme }) => theme.card.borderRadius}
      ${({ theme }) => theme.card.borderRadius} 0px 0px;
  }
`;
var Title = /* @__PURE__ */ __name(({ icon, children, ...elemProps }) => /* @__PURE__ */ React.createElement(Header_default, _extends({
  variant: "title"
}, elemProps), icon != null && /* @__PURE__ */ React.createElement(IconContainer, null, icon), children), "Title");
var Subtitle = styled(Paragraph).attrs(() => ({
  size: "md"
}))`
  color: ${({ theme }) => theme.color.text.tertiary};
`;
var SectionHeader = /* @__PURE__ */ __name(({ children, ...elemProps }) => /* @__PURE__ */ React.createElement(Header_default, _extends({
  variant: "section"
}, elemProps), children), "SectionHeader");
var Image = /* @__PURE__ */ __name(({ height, children, ...elemProps }) => /* @__PURE__ */ React.createElement(ImageWrapper, _extends({}, elemProps, {
  height
}), children), "Image");
var CollapsibleSection = /* @__PURE__ */ __name(({ id, defaultExpanded, title, children }) => {
  const [isOpen, { toggle }] = useToggle_default(defaultExpanded);
  return /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement("div", {
    id,
    onClick: toggle
  }, /* @__PURE__ */ React.createElement(Header_default, {
    variant: "section"
  }, /* @__PURE__ */ React.createElement(HeaderIcon, null, isOpen ? /* @__PURE__ */ React.createElement(ChevronUpIcon, null) : /* @__PURE__ */ React.createElement(ChevronDownIcon, null), /* @__PURE__ */ React.createElement(Spacer_default, {
    width: 0.5,
    height: 0
  })), title)), /* @__PURE__ */ React.createElement("div", null, isOpen && children), /* @__PURE__ */ React.createElement(Spacer_default, {
    height: 1
  }));
}, "CollapsibleSection");
var HeaderIcon = styled.div`
  display: flex;
`;
var Card_default = Object.assign(Card, {
  Title,
  SectionHeader,
  Subtitle,
  Body,
  Image,
  CollapsibleSection
});

export {
  Card_default
};
//# sourceMappingURL=chunk-PA3KMQZY.mjs.map